import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLanguageChange = (newLang: 'fr' | 'en' | 'de') => {
    setLanguage(newLang);
    
    // Map routes between languages
    const currentPath = location.pathname;
    
    // Main pages routing
    if (currentPath === '/' || currentPath === '/en' || 
        currentPath === '/new4' || currentPath === '/new4-en') {
      navigate(newLang === 'en' ? '/en' : '/');
    }
    // Add other route mappings as needed
  };
  
  return (
    <div className="inline-flex items-center gap-1 bg-gray-100 rounded-full p-1">
      <button
        onClick={() => handleLanguageChange('fr')}
        className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
          language === 'fr'
            ? 'bg-legatia-green text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        FR
      </button>
      <button
        onClick={() => handleLanguageChange('en')}
        className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
          language === 'en'
            ? 'bg-legatia-green text-white shadow-sm'
            : 'text-gray-600 hover:text-gray-900'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;